<template>
  <!--新建安全外链-->
  <section>
    <!--外链部分-->
    <div
      class="setNewLink"
      :class="$i18n.locale"
      :style="{visibility: visibility}"
    >
      <!--链接警告-->
      <div
        v-if="showAuthWarn || showApprovalWarn || showInApprovalWarn || showRefuseApproval"
        class="link-warn"
      >
        <span
          style="position: relative;display: inline-block;"
          v-html="warningTip"
        />
      </div>
      <!--外链中间内容部分-->
      <div
        class="content-box"
        :style="{paddingBottom: hasDelivery ? '122px' : '0'}"
      >
        <div class="dialog-content">
          <!--头部部分-->
          <div class="link-row">
            <span class="approval-tip" />
            <!--创建链接图标-->
            <span
              v-show="!hasDelivery"
              class="delivery-icon"
            >
              <svg class="icon icon-i-link">
                <use xlink:href="#link-share" />
              </svg>
            </span>
            <!--创建外链的提示-->
            <div
              v-show="!hasDelivery"
              class="link-url-span"
              :class="{'no-link-border': !hasDelivery}"
            >
              <span class="no-link">{{ $t('还没有创建分享链接') }}</span>
            </div>
            <!--链接创建成功后地址-->
            <div
              v-show="hasDelivery"
              class="link-url-span url-show"
            >
              <a
                class="has-link"
                target="_blank"
                :style="{width: add_link_pwd ? '197px' : '235px'}"
                @click="openClientWin(linkUrl)"
              >{{ linkUrl }}</a>
              <input
                ref="link_copy_box"
                v-model="link_url_copy"
                type="text"
                class="link_copy_box"
                :title="link_url_copy"
              >
              <span
                v-if="add_link_pwd && hasDelivery"
                class="link-txt-password"
              >({{ $t('提取码：') }}{{ param.password }})</span>
            </div>
            <!--头部按钮部分-->
            <input
              v-show="!hasDelivery"
              id="link-create"
              type="button"
              name="create"
              :class="['lv-bn','lv-80', 's-btn','cp',pwVerified?'':'create-btn-disable']"
              :value="this.$t('创建链接')"
              :disabled="showInApprovalWarn || needAuth || !pwVerified"
              @click="createLink"
            >
            <input
              v-show="hasDelivery&&!showUpdate"
              id="link-copy"
              type="button"
              name="copy"
              :class="['lv-bn','lv-80','s-btn','cp',pwVerified?'':'create-btn-disable']"
              :value="this.$t('复制')"
              :disabled="showInApprovalWarn || needAuth || !pwVerified"
              @click="setRichTpl"
            >
            <input
              v-show="hasDelivery&&showUpdate"
              id="link-copy-save"
              type="button"
              name="update"
              :class="['lv-bn','lv-80','s-btn','cp',pwVerified?'':'create-btn-disable']"
              :value="this.$t('保存并复制')"
              :disabled="showInApprovalWarn || needAuth || !pwVerified"
              @click="updateLink"
            >
            <!--右侧手机扫描的逻辑-->
            <div
              v-show="hasDelivery"
              id="link-share-two-dimensional-code-icon"
              class="link-share-two-dimensional-code-icon"
              @mouseenter="showQrcode"
              @mouseleave="hideQrcode"
            >
              <div
                v-show="qrcode_show"
                id="link-share-two-dimensional-code-box"
                class="link-share-two-dimensional-code-box"
              >
                <div
                  id="link-share-two-dimensional-code-pic"
                  class="link-share-two-dimensional-code-pic"
                  @contextmenu.stop
                >
                  <img
                    class="delivery-qrcode"
                    :src="qr_code_url"
                    :alt="this.$t('二维码')"
                  >
                </div>
                <div
                  id="link-share-two-dimensional-code-state"
                  class="link-share-two-dimensional-code-state"
                >
                  {{ $t('手机扫描快速分享链接至微信、QQ 等好友') }}
                </div>
              </div>
            </div>
          </div>

          <!--外链选项部分-->
          <div class="link-option">
            <!--备注名称-->
            <div
              v-if="hasDelivery"
              class="remark-row"
            >
              <span class="label">{{ $t('备注名：') }}</span>
              <input
                v-model="param.name"
                type="text"
                class="remark-name"
                maxlength="32"
                :disabled="showInApprovalWarn"
              >
              <span class="icon-remark">
                <svg class="icon">
                  <use xlink:href="#link-edit" />
                </svg>
              </span>
              <span
                v-show="maxlenWarn"
                class="maxlength-warn-txt"
              >{{ $t('最多可输入32个字符') }}</span>
            </div>

            <!--权限部分-->
            <div class="check-auth controlled-item">
              <span class="label">{{ $t('权限：') }}</span>
              <!--预览权限与普通外链有差异.安全外链默认可以预览-->
              <span
                class="item-wrapper"
                :class="{'disabled': controlledRule.forbiddenPreview || showInApprovalWarn}"
              >
                <input
                  id="preview_auth"
                  v-model="opt.preview"
                  type="checkbox"
                  :disabled="showInApprovalWarn"
                >
                <span
                  class="box-checkbox-inner"
                  :class="(opt.preview? (controlledRule.forbiddenPreview || showInApprovalWarn)? 'checkbox-disabled':'checkbox-checked': '')"
                  @click="checkOrNot(opt.preview,'preview')"
                />
                <label for="preview_auth">{{ $t('允许预览') }}</label>
              </span>
              <!--内部成员部分-->
              <span
                class="item-wrapper"
                :class="{'disabled': controlledRule.staffOnly || showInApprovalWarn || showAuthWarn}"
              >
                <input
                  id="link_out"
                  v-model="opt.link_out"
                  type="checkbox"
                  :disabled="showInApprovalWarn || showAuthWarn"
                >
                <span
                  class="box-checkbox-inner"
                  :class="(opt.link_out ? (controlledRule.staffOnly || showInApprovalWarn || showAuthWarn) ? 'checkbox-disabled':'checkbox-checked': '')"
                  @click="checkOrNot(opt.link_out,'link_out')"
                />
                <label
                  :class="{'disable-check':showAuthWarn}"
                  for="link_out"
                >{{ $t('仅内部成员可用') }}</label>
              </span>
            </div>

            <!--安全部分，安全外链-->
            <div class="secure-config">
              <span class="label">{{ $t('安全：') }}</span>
              <div class="secure-content controlled-item">
                <!--添加提取码-->
                <div
                  v-show="!add_link_pwd"
                  class="config-row"
                >
                  <span
                    class="add-link-pwd"
                    @click="addLinkPwd"
                  >{{ $t('添加链接提取码') }}</span>
                </div>
                <!--提取码展示部分-->
                <div
                  v-show="add_link_pwd"
                  class="config-row"
                >
                  <span class="label">{{ $t('提取码') }}</span>
                  <input
                    v-model="param.password"
                    type="text"
                    :class="pwVerified?'':'pw-input-red'"
                    :disabled="showInApprovalWarn"
                    @blur="passwordVerification"
                  >
                  <span
                    v-if="!controlledRule.needPassword"
                    class="rm-link-pwd"
                    @click="rmLinkPwd"
                  >
                    {{ $t('取消加密') }}
                  </span>
                </div>
                <!--时间有效期部分-->
                <div class="config-row">
                  <span class="label">{{ $t('有效期') }}</span>
                  <div class="calendar-box">
                    <el-date-picker
                      v-model="param.expiration"
                      :clearable="false"
                      :editable="false"
                      type="date"
                      placeholder="选择日期"
                      value-format="yyyy-MM-dd"
                      :picker-options="pickerOptions"
                      @change="datePicked"
                    />
                  </div>
                  <span
                    v-if="!param.delivery_expired"
                    class="link-em-days"
                  >{{ $t('距到期还有{d}天{h}时{m}分', {'d':lastday.days,'h':lastday.hours,'m':lastday.minutes}) }} </span>
                  <span
                    v-else
                    class="link_ex_msg"
                  >{{ $t('链接已过期') }}</span>
                </div>
                <!--下载次数的认证-->
                <div
                  v-show="opt.download && !controlledRule.forbiddenDownload"
                  class="config-row"
                >
                  <span class="label">{{ $t('可下载次数') }}</span>
                  <input
                    v-model="param.dl_limit"
                    type="text"
                    maxlength="4"
                    :disabled="showInApprovalWarn"
                    @keyup="param.dl_limit = checkVal(param.dl_limit)"
                  >
                  <span class="count"> {{ $t('次') }}</span>
                  <i
                    class="icon-caret_down"
                    @click="showLimit.splice(1,1,!showLimit[1])"
                  >
                    <svg class="icon icon-arrow">
                      <use :xlink:href="showLimit[1]? '#arr-up':'#arr-down'" />
                    </svg>
                  </i>
                  <ul
                    v-show="showLimit[1]"
                    class="dl-time"
                    @mouseleave="hideTime(1)"
                  >
                    <li
                      v-for="(item, index) in limits"
                      :key="index"
                      @click="setLimit(item,1)"
                    >
                      {{ item }}
                    </li>
                  </ul>
                  <span
                    v-if="showDlWarnMsg"
                    class="link_ex_msg"
                  >{{ dlWarnMsg }}</span>
                </div>
                <!--安全外链特有的部分-->
                <div class="securty-setting-box">
                  <!--阅读次数-->
                  <div class="config-row">
                    <span class="label">{{ $t('阅读次数') }}</span>
                    <input
                      v-model="param.security_setting.reading_num"
                      type="text"
                      maxlength="4"
                      :disabled="showInApprovalWarn"
                      @keyup="param.security_setting.reading_num = checkVal(param.security_setting.reading_num)"
                    ><span class="count"> {{ $t('次') }}</span>
                    <i
                      class="icon-caret_down"
                      @click="showLimit.splice(2,1,!showLimit[2])"
                    >
                      <svg class="icon icon-arrow">
                        <use :xlink:href="showLimit[2]? '#arr-up':'#arr-down'" />
                      </svg>
                    </i>
                    <ul
                      v-show="showLimit[2]"
                      class="dl-time"
                      @mouseleave="hideTime(2)"
                    >
                      <li
                        v-for="(item, index) in limits"
                        :key="index"
                        @click="setLimit(item,2)"
                      >
                        {{ item }}
                      </li>
                    </ul>
                    <span
                      v-if="showReadingNumWarnMsg"
                      class="link_ex_msg"
                    >{{ readingNumWarnMsg }}</span>
                  </div>
                  <!--阅读时长-->
                  <div class="config-row">
                    <span class="label">{{ $t('阅读时长') }}</span>
                    <input
                      v-model="param.security_setting.reading_time"
                      type="text"
                      maxlength="4"
                      :disabled="showInApprovalWarn"
                      @keyup="param.security_setting.reading_time = checkVal(param.security_setting.reading_time)"
                    ><span class="count"> {{ $t('小时') }}</span>
                    <i
                      class="icon-caret_down"
                      @click="showLimit.splice(3,1,!showLimit[3])"
                    >
                      <svg class="icon icon-arrow">
                        <use :xlink:href="showLimit[3]? '#arr-up':'#arr-down'" />
                      </svg>
                    </i>
                    <ul
                      v-show="showLimit[3]"
                      class="dl-time"
                      @mouseleave="hideTime(3)"
                    >
                      <li
                        v-for="(item, index) in limits"
                        :key="index"
                        @click="setLimit(item,3)"
                      >
                        {{ item }}
                      </li>
                    </ul>
                    <span
                      v-if="showReadingTimeWarnMsg"
                      class="link_ex_msg"
                    >{{ readingTimeWarnMsg }}</span>
                  </div>

                  <!--打印，只读，失效删除，阅读水印-->
                  <div class="config-row">
                    <span
                      class="item-wrapper"
                      :class="{'disabled': controlledRule.forbiddenPrinting}"
                    >
                      <input
                        id="printable"
                        v-model="param.security_setting.printable"
                        type="checkbox"
                        :disabled="showInApprovalWarn"
                      ><i
                        class="box-checkbox-inner"
                        :class="[(param.security_setting.printable? 'checkbox-checked': ''), {'checkbox-disabled': showInApprovalWarn}]"
                        @click="checkOrNotForSecurity(param.security_setting.printable,'printable')"
                      /><label for="printable">{{ $t('允许打印') }}</label>
                    </span>
                    <span
                      class="item-wrapper"
                      :class="{'disabled': controlledRule.onlyRead}"
                    >
                      <input
                        id="only_read"
                        v-model="param.security_setting.only_read"
                        type="checkbox"
                        :disabled="showInApprovalWarn"
                      ><i
                        class="box-checkbox-inner"
                        :class="[(param.security_setting.only_read? 'checkbox-checked': ''), {'checkbox-disabled': showInApprovalWarn}]"
                        @click="checkOrNotForSecurity(param.security_setting.only_read,'only_read')"
                      /><label for="only_read">{{ $t('文档只读') }}</label>
                    </span>
                    <span
                      class="item-wrapper"
                      :class="{'disabled': controlledRule.autoDelete}"
                    >
                      <input
                        id="auto_delete"
                        v-model="param.security_setting.auto_delete"
                        type="checkbox"
                        :disabled="showInApprovalWarn"
                      ><i
                        class="box-checkbox-inner"
                        :class="[(param.security_setting.auto_delete? 'checkbox-checked': ''), {'checkbox-disabled': showInApprovalWarn}]"
                        @click="checkOrNotForSecurity(param.security_setting.auto_delete,'auto_delete')"
                      /><label for="auto_delete">{{ $t('失效后删除') }}</label>
                    </span>
                    <div
                      class="config-row water-mark item-wrapper"
                      :class="{'disabled': controlledRule.waterMarkText && controlledRule.waterMarkText !== ''}"
                    >
                      <input
                        id="water_mark"
                        v-model="param.security_setting.water_mark"
                        type="checkbox"
                        :disabled="showInApprovalWarn"
                      >
                      <i
                        class="box-checkbox-inner"
                        :class="[(param.security_setting.water_mark? 'checkbox-checked': ''), {'checkbox-disabled': showInApprovalWarn}]"
                        @click="checkOrNotForSecurity(param.security_setting.water_mark,'water_mark')"
                      /><label for="water_mark">{{ $t('添加阅读水印') }}</label>
                      <input
                        v-show="param.security_setting.water_mark"
                        v-model="param.security_setting.water_mark_txt"
                        type="text"
                        :disabled="showInApprovalWarn"
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--链接说明部分-->
          <div
            v-ie-placeholder
            class="link-instruction"
          >
            <label class="label">{{ $t('说明:') }}</label>
            <input
              v-model="param.description"
              type="text"
              maxlength="300"
              :placeholder="this.$t('添加链接说明')"
              class="link-instruction-input"
              :disabled="showInApprovalWarn"
            >
          </div>
        </div>
      </div>
      <!--邮箱部分,历史，新链接-安全外链-->
      <div
        v-if="hasDelivery"
        class="more-option"
      >
        <!--邮箱部分-->
        <div
          v-show="hasDelivery"
          class="dialogfooter"
        >
          <div class="link-row add-email">
            <label
              class="label"
              style="vertical-align: top"
            >{{ $t('邮箱:') }}</label>
            <div id="add-email">
              <searchMember
                ref="member_list"
                :single="single"
                :type="searchMemberType"
                :position="position"
                :disable="showInApprovalWarn"
                :placeholder="$t(placeholder)"
                @watchSelected="watchSelected"
                @showTips="showTips"
              />
            </div>
            <div
              v-show="sendMailbtn"
              class="sendLink"
              @click="sendLink"
            >
              {{ $t('发送') }}
            </div>
          </div>
        </div>
        <!--创建新的链接和历史记录-->
        <div
          class="create-link-group newLink"
          @mouseenter="isShowNewLinkFromFoot = true;"
          @mouseleave="isShowNewLinkFromFoot = false;"
        >
          <ul
            v-show="(haveSecureDelivery||haveSmartshareDelivery) && isShowNewLinkFromFoot"
            class="create-link-options"
            :style="{top:haveSecureDelivery?haveSmartshareDelivery?'-110px':'-76px':'-76px'}"
          >
            <li
              v-for="(item, index) in link"
              v-if="item.show"
              :key="index"
              :data-cmd="item.ref"
              :data-operate-type="item.operateType"
              @click="newLinkFromFoot($event)"
            >
              {{ item.name }}
            </li>
          </ul>
          <span
            class="create-link"
            @click="newLinkDefaultFromFoot"
          >{{ $t('创建新链接') }}</span>
          <i v-show="(haveSecureDelivery||haveSmartshareDelivery) && isShowNewLinkFromFoot">
            <svg class="icon icon-blue-arrow">
              <use xlink:href="#blue-arr-down" />
            </svg>
          </i>
        </div>
        <span
          class="historyLink"
          @click="showHistoryLink"
        >{{ $t('管理历史链接') }}</span>
      </div>
    </div>
    <!--低版本的浏览器兼容,复制弹窗-->
    <lowBrowserCopy
      :copy-text="copyText"
      :visible.sync="lowBDialog"
    />
  </section>
</template>

<script>
/**
     * 安全链接展示备注
     * 安全链接管控：上传、下载、预览、仅内部成员使用
     * 最多阅读次数、最长阅读时长、文档只读、允许打印、失效后删除、添加水印
     */

// 引入
import store from 'store' // 引入store用于获取用户的数据信息
import * as Util from 'js/util/util'
import _$ from 'js/api/getdata.js'
import searchMember from './search-member.vue' // 邮箱查询组件
import lowBrowserCopy from './lowBrowserCopy' // 低版本浏览器的复制
import { RICH_TXT_COPY } from './rich-text-copy.js' // 复制组件的混入(这部分还需要再看下)
import { SHARE_TYPE } from '../index.js'
import { openUrlOutside } from '@filez/js-2-native'
// 采用const方式引入 防止变量名称修改
const { getData, postData } = require('js/api/getdata').default

export default {
  name: 'SecureLink',
  components: {
    searchMember,
    lowBrowserCopy,
  },
  mixins: [RICH_TXT_COPY],
  props: {
    otherData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // global
      hasDelivery: false, // 是否已经分享外链
      needAuth: false, // 创建外链是否需要权限

      // show-message顶部提示部分
      showAuthWarn: false, // 链接弹框里 显示需要实名认证提示
      showApprovalWarn: false, // 链接弹框里 显示需要审批提示
      showInApprovalWarn: false, // 链接弹框里 显示在审批中...提示
      showRefuseApproval: false, // 链接弹框里 显示在拒绝审批的提示
      warningTip: '', // 链接框里的提示语

      // link-row头部份
      visibility: 'hidden', // 是否显示链接内容， 初始为隐藏
      add_link_pwd: true, // 创建外链的密码
      linkUrl: '', // 外链地址
      link_url_copy: '', // 赋值外链地址(该字段再普通外链中变量名称有差异)
      pwVerified: true, // 提取码格式校验通过，默认true
      qrcode_show: false, // 默认不显示二维码
      qr_code_url: '', // 二维码内部跳转地址

      // 邮箱查询人员部分
      single: false,
      searchMemberType: 'email',
      position: 'top',
      placeholder: '点击或输入邮箱地址，多个地址以逗号或分号分隔',
      sendMailbtn: false, // 默认不显示按钮

      // 下载次数，阅读次数， 阅读时长
      showLimit: [false, false, false], // 默认全不显示
      limits: [this.$t('无限制'), '1', '2', '3'], // 下拉选项
      dlWarnMsg: this.$t('下载次数已用尽'),
      showDlWarnMsg: false,
      readingNumWarnMsg: this.$t('阅读次数已用尽'),
      showReadingNumWarnMsg: false,
      readingTimeWarnMsg: this.$t('阅读时长已用尽'),
      showReadingTimeWarnMsg: false,

      // 数据信息部分
      metaData: {},
      isfolder: '',
      deliveryCode: '',

      // opt-button 外链选项部分,备注部分
      maxlenWarn: false, // 备注名称超过长度的警告

      // time-picker 时间显示组件
      pickerOptions: { // 日期事件格式（element-ui组件特殊格式）
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        },
      },
      lastday: { // 剩余时间
        days: '',
        hours: '',
        minutes: '',
      },

      // 外链状态不部分，审批中
      // approvalCode: 0,        //审批码(安全外链不需要)
      linkStatus: {}, // 链接状态信息

      // 安全管控部分
      controlledRule: {}, // 安全管控按钮显示部分

      // 操作项部分
      opt: {
        upload: '',
        download: '',
        preview: '',
        link_out: '',
        mirror_version: '',
      },
      oldOpt: {
        upload: '',
        download: '',
        preview: '',
        link_out: '',
        mirror_version: '',
      },
      account_id: '',
      param: {
        neid: '',
        mode: '',
        password: '',
        expiration: '',
        description: '',
        name: '',
        dl_limit: this.$t('无限制'), // 下载次数限制
        delivery_expired: '', // 链接是否过期
        staff_only: 1, // 是否仅内部成员访问
        // 安全外链选项
        security_setting: {
          reading_time: this.$t('无限制'),
          reading_num: this.$t('无限制'),
          printable: 0,
          only_read: 0,
          auto_delete: 0,
          water_mark: 0,
          water_mark_txt: '',
        },
      },
      oldParam: {
        neid: '',
        mode: '',
        password: '',
        expiration: '',
        description: '',
        name: '',
        dl_limit: this.$t('无限制'), // 下载次数限制
        delivery_expired: '', // 链接是否过期
        staff_only: 1, // 是否仅内部成员访问
        // 安全外链选项
        security_setting: {
          reading_time: this.$t('无限制'),
          reading_num: this.$t('无限制'),
          printable: 0,
          only_read: 0,
          auto_delete: 0,
          water_mark: 0,
          water_mark_txt: '',
        },
      },

      // 底部外链切换和历史版本
      isShowNewLinkFromFoot: false,
      link: [
        {
          ref: 'commonLink',
          name: this.$t('普通链接'),
          operateType: 1,
          code: 1,
          vm: this,
          get show() {
            return true
          },
        },
        {
          ref: 'secureLink',
          name: this.$t('安全链接'),
          operateType: 1,
          code: 2,
          vm: this,
          get show() {
            const { vm } = this
            return vm.haveSecureDelivery
          },
        },
        { // 暂时没有smartShare
          ref: 'smartShare',
          name: 'SmartShare',
          operateType: 1,
          code: 3,
          vm: this,
          get show() {
            const { vm } = this
            return vm.haveSmartshareDelivery
          },
        },
      ],
    }
  },
  computed: {
    /**
             * 判断是否需要更新（复制和保存赋值按钮）
             */
    showUpdate() {
      // 判断老版本和新的
      const paramFlag = this.isObjectValueEqual(this.param, this.oldParam)
      const optFlag = this.isObjectValueEqual(this.opt, this.oldOpt)
      return !(paramFlag && optFlag)
    },
    /**
             * 判断是否有安全链接权限
             */
    haveSecureDelivery() {
      const selectedData = this.otherData && this.otherData.meta
      const { security_delivery } = store.getters.accountConfig
      const { is_dir, path_type } = selectedData
      return path_type === 'ent' && security_delivery == '2' && !is_dir
    },
    /**
             * 判断是否有smartshare权限
             */
    haveSmartshareDelivery() {
      return false // 先不做，默认没有smartShare
      // let selectedData = this.otherData && this.otherData.meta,
      //     {smartshare_delivery} = store.getters.accountConfig,
      //     {is_dir,mime_type,path} = selectedData;
      // let canSmartshare = false;
      // if (mime_type === '' || mime_type === undefined) {
      //     canSmartshare = Util.canSmartshare(path);
      // } else {
      //     canSmartshare = Util.canSmartshare(mime_type);
      // }
      // return smartshare_delivery == '1' && !is_dir && canSmartshare;
    },
  },
  watch: {
    /* 上传权限和始终链接到最新版本select联动 */
    // 'opt.upload'(val) {
    //     if (val) {
    //         this.opt.mirror_version = val ? 1 : 0;
    //     }
    // },
    'opt.mirror_version': function (val) {
      this.opt.mirror_version = val ? 1 : 0
    },
    'opt.download': function (val) {
      this.checkOpt()
      if (val) {
        // 需要把param.dl_limit 对应更改
        if (!this.deliveryCode || (this.otherData && this.otherData.new)) {
          this.param.dl_limit = (this.controlledRule.maxDownloadTimes && this.controlledRule.maxDownloadTimes !== -1) ? this.controlledRule.maxDownloadTimes : this.$t('无限制')
        }
      } else {
        // dl_limit -2 是因为不允许下载
        this.param.dl_limit = -2
      }
    },
    'opt.preview': function (val) {
      this.checkOpt()
    },
    'opt.upload': function (val) {
      this.checkOpt
    },
    'param.dl_limit': function (val) {
      this.checkDlLimit(val)
    },
    'param.security_setting.reading_time': function (val) {
      this.checkReadingTimeLimit(val)
    },
    'param.security_setting.reading_num': function (val) {
      this.checkReadingNumLimit(val)
    },
    'param.name': function (val) {
      this.$nextTick(() => {
        if (val && val.length == 32) {
          this.maxlenWarn = true
        } else {
          this.maxlenWarn = false
        }
      })
    },
    'param.expiration': function (newVal, oldVal) {
      let { expiration } = this.param
      if (new Date(expiration).toString() == 'Invalid Date') {
        expiration = expiration.substring(0, expiration.length - 5).replace(/-/g, '/').replace('T', ' ')
      }
      this.leftTimer(Util.formatDate(new Date(expiration), 'yyyy-MM-dd')) // 监听日期变化，计算距离结束时间
    },
    'param.password': function (val) {
      this.$nextTick(() => {
        this.param.password = this.param.password.replace(/[\W]/g, '')
      })
    },
    'param.security_setting.auto_delete': function (val) {
      this.param.security_setting.auto_delete = val ? 1 : 0
    },
    'param.security_setting.printable': function (val) {
      this.param.security_setting.printable = val ? 1 : 0
    },
    'param.security_setting.water_mark': function (val) {
      this.param.security_setting.water_mark = val ? 1 : 0
    },
    'param.security_setting.only_read': function (val) {
      this.param.security_setting.only_read = val ? 1 : 0
    },
  },
  async created() {
    // 赋值规则,安全管控
    await this.getDeliveryRule()
    // 验证账户权限状态,未实名用户弹出提示
    this.checkAccountAuthStatus()
    // 初始化数据
    this.init()
  },
  methods: {
    // --------------------------数据初始化部分--------------------------------
    /**
             * 数据的初始化
             */
    async init() {
      this.metaData = this.otherData && this.otherData.meta // 获取选中项的相关数据
      this.isfolder = this.metaData.isDir || this.metaData.is_dir
      this.deliveryCode = (this.otherData && this.otherData.historyCode) || this.metaData.delivery_code
      if (this.otherData && this.otherData.isNew) { // 传isNew参数为新建链接逻辑
        this.newLink()
        this.getLinkStatus()
      } else { // deliveryCode不空时，获取链接
        await this.getLinkData()
        await this.getSecureLinkData()
        this.renderControlledRule()
      }
    },
    /**
             * 创建新的链接
             */
    async newLink() {
      this.initParam()
      this.initOpt()
      this.renderControlledRule()
      this.deliveryCode = ''
      this.linkUrl = ''
      this.link_url_copy = ''
      this.qr_code_url = ''
      this.add_link_pwd = true // 添加提取码
      this.hasDelivery = false
      this.visibility = 'visible' // 让链接内容显示出来
    },
    /**
             * 初始化外链信息
             */
    initParam() {
      // 初始化密码
      this.param.password = this.createPassword(4)
      this.param.expiration = new Date()
      this.param.expiration.setDate(new Date().getDate() + (this.controlledRule.maxValid || 7))// 默认到期时间 为设置的最长有效期  没有的时候默认为7
      this.param.dl_limit = this.$t('无限制')
      this.param.delivery_expired = false
      this.param.description = ''
      this.param.name = ''
      // 安全部分
      this.param.security_setting.auto_delete = this.param.security_setting.printable = true
      // param加入neid，name
      const { neid, name } = this.metaData
      Object.assign(this.param, { neid, name })
      // init->newLink调用initParam
      this.getAccessModeAuth(this.metaData.access_mode)
    },
    /**
             * 初始化按钮
             */
    initOpt() {
      // 需要根据权限判定
      const { canPreview, canDownload } = this.metaData
      this.opt.upload = false // 安全外链不能上传，一直为false;
      this.opt.preview = canPreview
      this.opt.download = canDownload
    },
    /**
             * 获取链接的状态
             */
    getLinkStatus() { // 获取链接状态
      // 从prefixHandler传入，减少请求
      if (this.otherData && this.otherData.deliveryStatus) {
        this.linkStatus = this.otherData.deliveryStatus
        this.resolveDeliveryStatus()
        return
      }
      getData('getLinkStatus', { neid: this.param.neid }).then((res) => {
        if (res.status == 200) {
          this.linkStatus = res.data
          this.resolveDeliveryStatus()
        }
      }).catch((err) => {
        console.log(err.response)
      })
    },
    /**
             * 获取分享外链数据信息
             */
    async getLinkData() { // 获取链接基本信息
      const params = {
        url: `/${this.deliveryCode}`,
      }
      await getData('get_delivery_info', params).then((res) => {
        if (res.status == 200) {
          const data = this.deliveryInfo = res.data
          this.getAccessModeAuth(data.access_mode)
          this.link_url_copy = this.linkUrl = data.url
          this.add_link_pwd = data.has_password
          if (this.linkUrl) this.hasDelivery = true
          this.resolveLinkAuth(data.mode)
          this.deliveryCode = data.code
          this.qr_code_url = `${window.location.origin}/v2/delivery/qrcode?delivery_code=${this.deliveryCode}&account_id=${this.account_id}`

          this.setOpt(res.data, false)
          this.setOpt(res.data, true)
          this.setParam(res.data, false)
          this.setParam(res.data, true)
          setTimeout(() => {
            this.visibility = 'visible' // 获取数据后显示链接内容
          }, 0)
          if (data.approval !== 0) { // 当链接与审批有关时
            this.setApprovalLink(data, this.showAuthWarn)
          }
        }
      })
    },
    /**
             * 获取分享安全外链信息
             */
    async getSecureLinkData() { // 获取安全链接
      if (!this.deliveryCode) return
      const params = {
        delivery_code: this.deliveryCode,
      }
      await getData('getSecureDeliveryInfo', params).then((res) => {
        if (res.status == 200) {
          this.deliveryInfo.security_setting = res.data
          this.setSecurityParam(res.data, true)
          this.setSecurityParam(res.data, false)
        }
      })
    },
    /**
             * 审批外链,获取审批外链状态,并显示相应的提示
             */
    setApprovalLink(data, authWarn = false) { // 设置与审批相关的内容
      const resData = data
      if (resData.approval == 1) {
        [this.showAuthWarn, this.showApprovalWarn, this.showInApprovalWarn, this.showRefuseApproval] = [authWarn, false, true, false] // 展示出在审批中的提示
        this.warningTip = `<i class='icon-link-warn-icon' style='margin-right:6px'></i>${this.$t('审批中....该链接需要审批后生效')}`
      } else if (resData.approval == 2) {
        [this.showAuthWarn, this.showApprovalWarn, this.showInApprovalWarn, this.showRefuseApproval] = [authWarn, false, false, true] // 展示出已拒绝审批的提示
        this.warningTip = `<i class='icon-link-warn-icon' style='position: absolute;top:2px;'></i><span style='display: inline-block;text-align: left;padding-left: 25px;'>${this.$t('审批未通过，')}<a href='/list/message'>${this.$t('查看未通过原因，')}</a>${this.$t('您可以修改原链接或者创建新链接')}</span>`
      }
      if (authWarn) { // 如果未实名认证，就显示未实名认证的提示
        this.warningTip = `<i class='icon-link-warn-icon' style='margin-right:6px'></i>${this.$t('未实名认证账号，只能创建内部分享链接')}`
      }
    },

    // --------------------非初始化流程验证部分------------------------------
    /**
             * 验证下载次数的规范
             */
    checkVal(val) {
      if (val.length == 1) {
        return val.replace(/[^1-9]/g, '')
      }
      return val.replace(/\D/g, '')
    },
    /**
             * 隐藏下拉（下载，阅读次数，阅读时长）列表
             */
    hideTime(type) {
      this.showLimit.splice(type, 1, false)
    },
    /**
             * 设置下拉（下载，阅读次数，阅读时长）次数
             */
    setLimit(val, type) {
      switch (type) {
        case 1:
          this.param.dl_limit = val
          break
        case 2:
          this.param.security_setting.reading_num = val
          break
        case 3:
          this.param.security_setting.reading_time = val
          break
      }
      this.hideTime(type)
    },
    /**
             * 显示二维码
             */
    showQrcode() {
      if (this.showInApprovalWarn) { // 链接处于审批中，不可添加提取码
        return
      }
      this.qrcode_show = true
    },
    /**
             * 隐藏二维码
             */
    hideQrcode() {
      this.qrcode_show = false
    },
    /**
             * 权限按钮选中部分
             */
    checkOrNot(check, t, e) {
      if (this.showInApprovalWarn) e.preventDefault()
      if (this.showAuthWarn && t === 'link_out') e.preventDefault()
      check = !check
      this.opt[t] = check
    },
    /**
             * 打印，只读，失效删除，水印
             */
    checkOrNotForSecurity(check, t) {
      check = !check
      this.param.security_setting[t] = check ? 1 : 0
    },
    /**
             * 创建外链密码
             */
    addLinkPwd() {
      this.add_link_pwd = true
      this.createPassword(4)
    },
    /**
             * 删除外链密码
             */
    rmLinkPwd() {
      this.add_link_pwd = false
      this.param.password = ''
    },
    /**
             * 设置到期时间
             */
    leftTimer(enTime) {
      if (enTime.toString().indexOf('-') > -1) {
        const timeArr = enTime.split('-')
        const y = timeArr[0]
        const m = timeArr[1] - 1
        const d = timeArr[2]

        const leftTime = new Date(y, m, d, 23, 59, 59) - new Date() // 计算剩余的毫秒数
        const days = parseInt(leftTime / 1000 / 60 / 60 / 24, 10) // 计算剩余的天数
        const hours = parseInt(leftTime / 1000 / 60 / 60 % 24, 10) // 计算剩余的小时
        const minutes = parseInt(leftTime / 1000 / 60 % 60, 10)// 计算剩余的分钟

        this.lastday.days = days
        this.lastday.hours = hours
        this.lastday.minutes = minutes
      }
    },
    /**
             * 点击链接地址跳转的方法
             */
    openClientWin(param) {
      if (Util.isClient()) {
        openUrlOutside({ url: param })
      } else {
        window.open(param, '_blank')
      }
    },
    /**
             * 重置警告
             */
    resetWarnState() {
      [this.showAuthWarn, this.showApprovalWarn, this.showInApprovalWarn, this.showRefuseApproval] = [false, false, false, false] // 展示出来需要审批的提示
      this.warningTip = ''
    },
    /**
             * 异常提示数据展示
             */
    changeWarnMsg({
      contentTarget, content, showTarget, isShow,
    }) {
      this[contentTarget] = content
      this[showTarget] = isShow
    },
    /**
             * @description 提取码长度校验 4-20 数字或字母组合 不符合不能创建
             */
    passwordVerification() {
      const pwLen = this.param.password.length
      if (pwLen < 4 || pwLen > 20) {
        this.pwVerified = false
        window.$toast.simpleShow(this.$t('请输入4-20个英文字或数字'), 'error')
      } else {
        this.pwVerified = true
      }
    },
    /**
             * 判断选择至少含有一种权限
             */
    hasLeastOneAuth(opt) {
      // 根据权限来检测是否至少有一种权限
      const auth = ['Download', 'Preview', 'Upload']
      let authNum = 0
      for (let i = 0; i < auth.length; i++) {
        if (this.metaData[`can${auth[i]}`]) {
          // 有权限的才判断
          if (opt[auth[i].toLowerCase()]) {
            authNum++
          }
        }
      }
      return authNum > 0
    },
    /**
             *@description 日期控件改变状态
             */
    datePicked(date) {
      const selectDate = new Date(date).getTime(); const currentDate = new Date().getTime()
      if (selectDate > currentDate) {
        this.param.delivery_expired = false
      }
      this.leftTimer(date)
    },
    /**
             * 进入外链分享列表界面
             */
    showHistoryLink() {
      this.$emit('history', 'mgdelivery', { meta: this.metaData })
    },
    // ----------------------外链权限设置部分---------------------------
    /**
             * 设置外链的权限
             */
    getLinkAuth() {
      if (this.opt.upload && this.opt.download && this.opt.preview) {
        this.param.mode = 'rwp'
      } else if (this.opt.upload && this.opt.download) {
        this.param.mode = 'rw'
      } else if (this.opt.upload && this.opt.preview) {
        this.param.mode = 'wp'
      } else if (this.opt.download && this.opt.preview) {
        this.param.mode = 'rp'
      } else if (this.opt.upload) {
        this.param.mode = 'w'
      } else if (this.opt.download) {
        this.param.mode = 'r'
      } else if (this.opt.preview) {
        this.param.mode = 'p'
      }
    },
    /**
             * 解析外链的权限
             */
    resolveLinkAuth(mode) {
      if (mode == 'rwp') {
        this.opt.upload = this.opt.download = this.opt.preview = true
      } else if (mode == 'rw') {
        this.opt.upload = this.opt.download = true
      } else if (mode == 'wp') {
        this.opt.upload = this.opt.preview = true
      } else if (mode == 'rp') {
        this.opt.download = this.opt.preview = true
      } else if (mode == 'w') {
        this.opt.upload = true
      } else if (mode == 'r') {
        this.opt.download = true
      } else if (mode == 'p') {
        this.opt.preview = true
      }
    },
    // +----------------------顶部创建外链，复制，保存等逻辑-----------------------
    /**
             * 创建外链
             */
    createLink() {
      this.getLinkAuth()
      if (this.add_link_pwd) this.param.password
      const data = {
        neid: this.param.neid,
        mode: this.param.mode,
        password: this.param.password,
        expiration: this.param.expiration,
        dl_limit: (this.param.dl_limit === this.$t('无限制') || !this.param.dl_limit) ? -1 : this.param.dl_limit,
        security: 1,
        mirror_ver: 1,
        description: this.param.description,
      }

      if (this.controlledRule.forbiddenDownload
                    || !this.metaData.canDownload
                    || this.isfolder) {
        // 暂定-2
        data.dl_limit = -2
      }
      const security_setting = JSON.parse(JSON.stringify(this.param.security_setting))

      if (this.param.security_setting.reading_time == this.$t('无限制')
                || !this.param.security_setting.reading_time) security_setting.reading_time = -1

      if (this.param.security_setting.reading_num == this.$t('无限制')
                || !this.param.security_setting.reading_num) security_setting.reading_num = -1

      if (this.opt.link_out) data.staff_only = 1

      data.security_setting = JSON.stringify(security_setting)

      // 这里需要审批外联
      if (this.linkStatus.must_approval) { // 出现审批申请弹框
        data.linkStatus = this.linkStatus // 链接状态信息
        data.security = 1
        this.$emit('reqApproval', data)
        // this.$emit('setCmd', {name: 'reqApproval', operateType: '1'}, data);
        return
      }

      // 创建外链数据
      postData('createLink', data).then((res) => {
        if (res.status == 200) {
          this.deliveryInfo = res.data
          this.linkUrl = res.data.url
          this.hasDelivery = true
          this.deliveryCode = res.data.code
          // 生成二维码链接
          this.qr_code_url = `${window.location.origin}/v2/delivery/qrcode?delivery_code=${this.deliveryCode}&account_id=${this.account_id}`
          this.setOpt(res.data, false)
          this.setOpt(res.data, true)
          this.setParam(res.data, false)
          this.setParam(res.data, true)
          this.setSecurityParam(res.data.security_setting, true)
          this.setSecurityParam(res.data.security_setting, false)
          this.updateListItem(res.data.code)
        } else {
          window.$toast.simpleShow(res.data.message, 'warn')
        }
      }).catch((error) => {
        if (error.response) {
          const err = error.response.data
          window.$toast.simpleShow(err.message, 'error')
        }
      })
    },
    /*
             *保存并复制
            */
    updateLink() {
      this.getLinkAuth()
      const data = {
        delivery_code: this.deliveryCode,
        mode: this.param.mode,
        password: this.param.password,
        expiration: this.param.expiration,
        name: this.param.name,
        dl_limit: (this.param.dl_limit === this.$t('无限制') || !this.param.dl_limit) ? -1 : this.param.dl_limit,
        security: 1,
        mirror_ver: 1,
        description: this.param.description,
      }
      const security_setting = JSON.parse(JSON.stringify(this.param.security_setting))

      if (this.controlledRule.forbiddenDownload
                    || !this.metaData.canDownload
                    || this.isfolder) {
        // 暂定-2
        data.dl_limit = -2
      }

      if (this.param.security_setting.reading_time == this.$t('无限制')) security_setting.reading_time = -1

      if (this.param.security_setting.reading_num == this.$t('无限制')) security_setting.reading_num = -1

      if (this.opt.link_out) data.staff_only = 1

      data.security_setting = JSON.stringify(security_setting)

      if (this.linkStatus.must_approval == true) {
        data.linkStatus = this.linkStatus
        // //显示审批外链弹窗
        this.$emit('reqApproval', data)
        // this.$emit('setCmd', {name: 'reqApproval', operateType: '1'}, data);
      } else {
        // Util.compactObj(data, Util.isEmpty)
        postData('updateLink', data).then((res) => {
          if (res.status == 200) {
            this.deliveryInfo = res.data
            this.param.name = res.data.name
            this.setOpt(res.data, false)
            this.setOpt(res.data, true)
            this.setParam(res.data, false)
            this.setParam(res.data, true)
            this.setSecurityParam(res.data.security_setting, true)
            this.setSecurityParam(res.data.security_setting, false)
            this.updateListItem(res.data.code)
          } else {
            window.$toast.simpleShow(res.data.message, 'warn')
          }
        }).catch((error) => {
          if (error.response) {
            const err = error.response.data
            window.$toast.simpleShow(err.message, 'warn')
          }
        })
        // 复制文本放在异步外(这部分代码有ie兼容等，需要特殊处理，先放下)
        this.setRichTpl()
      }
    },
    /**
             * 更新显示列表
             */
    updateListItem(deliveryCode) {
      if (!this.$store.state.selectedData.data[0]) return
      const newData = { ...this.$store.state.selectedData.data[0].data }
      const { index } = this.$store.state.selectedData.data[0]
      newData.delivery_code = deliveryCode
      newData.delivery_expired = this.param.delivery_expired
      // ??抛出事件暂时不处理
      // this.$emit('refreshItem',{newData, index})
    },

    // +-----------------------工具函数-------------------------
    // 创建外链随机密码
    createPassword(len) {
      // eslint-disable-next-line no-array-constructor
      const seed = new Array('a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z')
      const lenSeed = seed.length
      let str = ''
      for (let i = 0; i < len; i++) {
        const j = Math.floor(Math.random() * lenSeed)
        str += seed[j]
      }
      this.param.password = str
      return str
    },
    /**
             * 比较两个对象是否相等
            */
    isObjectValueEqual(a, b) {
      const aProps = Object.getOwnPropertyNames(a)
      const bProps = Object.getOwnPropertyNames(b)

      if (aProps.length != bProps.length) {
        return false
      }

      for (let i = 0; i < aProps.length; i++) {
        const propName = aProps[i]
        if (propName === '__ob__') continue
        // 👇 security_setting
        const flag = a[propName] instanceof Object && !(a[propName] instanceof Date)
        if (flag) {
          return this.isObjectValueEqual(a[propName], b[propName])
        }
        if (a[propName].toString() !== b[propName].toString()) {
          return false
        }
      }
      return true
    },
    // +-----------------------发送邮件部分------------------------
    /**
             * 发送外链分享链接
             */
    sendLink() {
      const key = this.$refs.member_list.searchMemberParams.keyword.trim()
      const { selected } = this.$refs.member_list
      if (key !== '') {
        if (!Util.validEmail(key)) {
          selected.push({ name: key, error: true })
          window.$toast.simpleShow(this.$t('以下标红的邮箱格式不正确，检查一下吧'), 'warn')
          this.$refs.member_list.searchMemberParams.keyword = ''
          return
        }
        selected.push({ name: key })
        this.$refs.member_list.searchMemberParams.keyword = ''
      }
      if (document.querySelector('.email-error')) {
        window.$toast.simpleShow(this.$t('以下标红的邮箱格式不正确，检查一下吧'), 'warn')
        return
      }
      const data = {
        link: this.linkUrl,
        message: '',
        isfolder: this.isfolder,
        name: Util.resolvePath((this.metaData && this.metaData.path) || store.state.selectedData.data[0].data.path).name,
        path: (this.metaData && this.metaData.path) || store.state.selectedData.data[0].data.path,
        extractionCode: this.param.password,
      }
      const emailList = this.$refs.member_list.selected
      data.email = ''
      if (emailList.length === 0) {
        window.$toast.simpleShow(this.$t('邮箱不能为空'), 'warn')
        return
      }
      for (let i = 0; i < emailList.length; i++) {
        data.email += `${(emailList[i].name).toString()};`
      }
      this.$refs.member_list.saveRecent(data.email) // 保存最近使用的邮箱
      data.email = data.email.substr(0, data.email.length - 1)

      postData('sendLink', data).then((res) => {
        if (res.status == 200) {
          this.hasDelivery = true
          // 关闭弹窗
          this.$emit('closeDialog', 'close')
          // this.$emit('closeParentDialog')
          window.$toast.simpleShow(res.data.msg, 'success')
        }
      }).catch((error) => {
        // 失败提示语，和web保持一致。
        window.$toast.simpleShow(this.$t('发送失败，请重新发送'), 'error')
      })
    },
    /**
             * 显示提示数据信息
             */
    showTips(info) {
      window.$toast.simpleShow(info, 'warn')
    },
    /**
             * 显示发送右键按钮
             */
    watchSelected() {
      this.sendMailbtn = true// 显示发送邮件按钮
    },
    // +--------------创建其他种类的链接-----------------------
    /**
             * 条目数量的验证
             */
    async checkLinkNum() {
      // 条数检查
      const res = await _$.getData('linkHistory', { neid: this.metaData.neid })
      if (res.status == 200) {
        return res.data.length
      }
      return 0
    },
    /**
             * 添加其他种类链接
             */
    async newLinkFromFoot(e, name) {
      const linkNum = await this.checkLinkNum()
      if (linkNum >= SHARE_TYPE.limitNum) { // 链接总数达到200不能继续创建
        // 提示信息(确认并回调下载)
        window.$confirm.show({
          value: true,
          isShow: true,
          sureBtn: '知道了',
          onlyOne: true,
          title: '提示',
          isDescribe: true,
          describe: '请删除无用链接后再重试创建',
          content: `您在该文件/文件夹创建的链接已达到${SHARE_TYPE.limitNum}个上线`,
        })
        // 关闭分享详情弹窗
        this.$emit('closeDialog', 'close')
        return
      }
      // let target = e.target || e.srcElement,
      //     name = Util.dataset(target).cmd
      if (e.button === 0) {
        if (name === 'secureLink') {
          this.isShowNewLinkFromFoot = false
          if (this.otherData) this.otherData.detail = ''
          await this.getDeliveryRule()
          this.resetWarnState()
          this.checkAccountAuthStatus()
          this.newLink()
          return
        }
        if (!name) name = 'commonLink'
        // 不是通用外链，抛出事件重新绘制
        this.$emit('create', name, this.otherData.meta)
      }
    },
    /**
             * 直接点击创建外链，生成默认的当前显示的外链(默认没有其他选项的链接)
             */
    async newLinkDefaultFromFoot() {
      const linkNum = await this.checkLinkNum()
      if (linkNum >= SHARE_TYPE.limitNum) { // 链接总数达到200不能继续创建
        // 提示信息(确认并回调下载)
        window.$confirm.show({
          value: true,
          isShow: true,
          sureBtn: '知道了',
          onlyOne: true,
          title: '提示',
          isDescribe: true,
          describe: '请删除无用链接后再重试创建',
          content: `您在该文件/文件夹创建的链接已达到${SHARE_TYPE.limitNum}个上线`,
        })
        // 关闭分享详情弹窗
        this.$emit('closeDialog', 'close')
        return
      }
      if (this.haveSecureDelivery) return
      // 不是通用外链，抛出事件重新绘制
      this.$emit('create', name, this.otherData.meta)
    },
    // ---------------------设置函数部分---------------------------
    /**
             * 设置安全外链的参数
             */
    setSecurityParam(meta, old) {
      const tempParam = old ? this.oldParam : this.param
      tempParam.security_setting = {
        auto_delete: meta.auto_delete,
        only_read: meta.only_read,
        printable: meta.printable,
        reading_num: meta.reading_num === -1 ? this.$t('无限制') : meta.reading_num,
        reading_time: meta.reading_time === -1 ? this.$t('无限制') : meta.reading_time,
        water_mark: meta.water_mark,
        water_mark_txt: meta.water_mark_txt,
      }
    },
    /**
             * 设置外链参数
             */
    setParam(meta, old) {
      const tempParam = old ? this.oldParam : this.param
      tempParam.neid = meta.neid
      tempParam.mode = meta.mode
      tempParam.password = meta.password
      tempParam.expiration = meta.expiration
      tempParam.delivery_expired = meta.delivery_expired
      tempParam.description = meta.description
      tempParam.name = meta.name
      tempParam.dl_limit = meta.rest_dl === -1 ? this.$t('无限制') : meta.rest_dl
      tempParam.staff_only = meta.only_staff
      // 修正dl_limit
      if (!this.opt.download || this.controlledRule.forbiddenDownload) {
        tempParam.dl_limit = -2
      }
    },
    /**
             * 设置选项参数
             */
    setOpt(meta, old) {
      const tempOpt = old ? this.oldOpt : this.opt
      tempOpt.download = meta.mode.indexOf('r') > -1
      tempOpt.preview = meta.mode.indexOf('p') > -1
      tempOpt.upload = meta.mode.indexOf('w') > -1
      tempOpt.link_out = !!meta.only_staff
      tempOpt.mirror_version = meta.mirror_version
    },

    // +---------------------链接管控验证和权限等验证部分----------------------------
    /**
             * 获取验证规则
             */
    async getDeliveryRule() {
      // 如果有传入的规则，采用传入的规则
      if (this.otherData && this.otherData.detail) {
        this.controlledRule = JSON.parse(this.otherData.detail)
      }
    },
    /**
             * 验证用户权限，未实名用户弹出提示
             */
    checkAccountAuthStatus() {
      this.showAuthWarn = (store.state.lenovoData.accountInfo.account_auth_status === false)
      if (this.showAuthWarn) {
        this.warningTip = `<i class='icon-link-warn-icon' style='margin-right:6px'></i>${this.$t('未实名认证账号，只能创建内部分享链接')}`
        this.opt.link_out = true
      }
    },
    /**
             * 权限赋值到对象
             */
    getAccessModeAuth(access_mode) {
      // deliveryInfo这个字段来自混入,后面处理
      // if (!access_mode) {
      //     access_mode = this.deliveryInfo.access_mode
      // }
      const auth = Util.getPrivatePrivilege(Util.resolveFileAction(access_mode))
      this.metaData.canUpload = auth.canUpload && this.metaData.is_dir
      this.metaData.canPreview = auth.canPreview
      this.metaData.canDownload = auth.canDownload
    },
    /**
             * 管控规则
             */
    renderControlledRule() {
      // 将管控禁用项应用
      // opt部分
      const rule = this.controlledRule
      this.opt.preview = rule.forbiddenPreview ? false : this.opt.preview
      this.opt.download = rule.forbiddenDownload ? false : this.opt.download
      this.opt.link_out = rule.staffOnly ? true : this.opt.link_out
      // 安全外链mirror_version 一直为1
      // this.opt.mirror_version = rule.noMirror ? true : this.opt.mirror_version;
      // param部分
      // 针对dl_limit 判断，不能下载的时候就不变动他
      if (this.controlledRule.forbiddenDownload
                    || this.metaData.canDownload
                    || this.opt.download
                    || this.param.dl_limit === 0) {
        this.param.dl_limit = this.param.dl_limit
      } else {
        this.param.dl_limit = (rule.maxDownloadTimes && rule.maxDownloadTimes !== -1) ? rule.maxDownloadTimes : this.param.dl_limit
      }
      // this.param.dl_limit = (rule.maxDownloadTimes && rule.maxDownloadTimes !== -1) ? rule.maxDownloadTimes : this.param.dl_limit
      this.param.security_setting.water_mark_txt = (!rule.waterMarkText || (rule.waterMarkText === '')) ? '' : rule.waterMarkText
      this.param.security_setting.water_mark = (!rule.waterMarkText || (rule.waterMarkText === '')) ? 0 : 1
      this.param.security_setting.printable = rule.forbiddenPrinting ? 0 : this.param.security_setting.printable
      this.param.security_setting.only_read = rule.onlyRead ? 1 : this.param.security_setting.only_read
      this.param.security_setting.auto_delete = rule.autoDelete ? 1 : this.param.security_setting.auto_delete
      this.param.security_setting.reading_num = (rule.maxReadingNum && rule.maxReadingNum !== -1) ? rule.maxReadingNum : this.param.security_setting.reading_num
      this.param.security_setting.reading_time = (rule.maxReadingTime && rule.maxReadingTime !== -1) ? rule.maxReadingTime : this.param.security_setting.reading_time
    },
    /**
             * 解析规则
             */
    resolveDeliveryStatus() {
      // must_approval 如果为false的时候  没有approval_type 字段，给赋默认0
      // 安全外链没有用到approvalCode，先不使用
      // this.approvalCode = this.linkStatus.approval_type || 0;
      if (this.linkStatus.must_approval == true) {
        // // 审批的默认勾选项
        if (this.showAuthWarn) { // 如果未实名认证，就显示未实名认证的提示
          [this.showApprovalWarn, this.showInApprovalWarn, this.showRefuseApproval] = [false, false, false]
        } else {
          [this.showAuthWarn, this.showApprovalWarn, this.showInApprovalWarn, this.showRefuseApproval] = [false, true, false, false] // 展示出来需要审批的提示
          this.warningTip = `<i class='icon-link-warn-icon' style='margin-right:6px'></i>${this.$t('该链接需要审批后生效')}`
        }
      }
    },

    /**
             * 下载次数的安全管控提示
             */
    checkDlLimit(val) {
      const { maxDownloadTimes } = this.controlledRule
      if (val === 0) {
        this.changeWarnMsg({
          contentTarget: 'dlWarnMsg',
          content: this.$t('下载次数已用尽'),
          showTarget: 'showDlWarnMsg',
          isShow: true,
        })
        return
      }
      if (maxDownloadTimes && maxDownloadTimes !== -1) {
        // 对下载次数有最大限制
        if (val > maxDownloadTimes) {
          this.changeWarnMsg({
            contentTarget: 'dlWarnMsg',
            content: `${this.$t('最多可下载')} ${maxDownloadTimes} ${this.$t('次')}`,
            showTarget: 'showDlWarnMsg',
            isShow: true,
          })
          this.needAuth = true
        } else {
          this.changeWarnMsg({
            contentTarget: 'dlWarnMsg',
            isShow: false,
          })
          this.needAuth = false
        }
      }
    },

    /**
             * 阅读次数的安全管控提示
             */
    checkReadingNumLimit(val) {
      const { maxReadingNum } = this.controlledRule
      if (val === 0) {
        this.changeWarnMsg({
          contentTarget: 'readingNumWarnMsg',
          content: this.$t('阅读次数已用尽'),
          showTarget: 'showReadingNumWarnMsg',
          isShow: true,
        })
      }
      if (maxReadingNum && maxReadingNum !== -1) {
        // 对阅读次数有最大限制
        if (val > maxReadingNum) {
          this.changeWarnMsg({
            contentTarget: 'readingNumWarnMsg',
            content: `${this.$t('最多可阅读')} ${maxReadingNum} ${this.$t('次')}`,
            showTarget: 'showReadingNumWarnMsg',
            isShow: true,
          })
          this.needAuth = true
        } else {
          this.changeWarnMsg({
            contentTarget: 'readingNumWarnMsg',
            isShow: false,
          })
          this.needAuth = false
        }
      }
    },

    /**
             * 阅读时长的安全管控提示
             */
    checkReadingTimeLimit(val) {
      const { maxReadingTime } = this.controlledRule
      if (val === 0) {
        this.changeWarnMsg({
          contentTarget: 'readingTimeWarnMsg',
          content: this.$t('阅读时长已用尽'),
          showTarget: 'showReadingTimeWarnMsg',
          isShow: true,
        })
      }
      if (maxReadingTime && maxReadingTime !== -1) {
        // 对阅读时长有最大限制
        if (val > maxReadingTime) {
          this.changeWarnMsg({
            contentTarget: 'readingTimeWarnMsg',
            content: `${this.$t('最多可阅读')} ${maxReadingTime} ${this.$t('小时')}`,
            showTarget: 'showReadingTimeWarnMsg',
            isShow: true,
          })
          this.needAuth = true
        } else {
          this.changeWarnMsg({
            contentTarget: 'readingTimeWarnMsg',
            isShow: false,
          })
          this.needAuth = false
        }
      }
    },

    /**
             * 此处通过showUploadAuth判断是否为文件夹，文件无上传权限
             */
    checkOpt() {
      const flag = this.hasLeastOneAuth(this.opt)
      if (!flag) {
        window.$toast.simpleShow(this.$t('请至少选择一种权限'), 'warn')
        this.needAuth = true
      } else {
        this.needAuth = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import '~less/variable.less';
@import '~less/button.less';
@import "~less/file.less";
@import "~less/sharedialog.less";

.setNewLink{
  min-width: 520px;
}
.link-warn{
  font-size: 14px;
  letter-spacing: 0.2px;
  z-index: 11;
  background: #fff1dc;
  left: 0;
  top: 50px;
  color: #FFAB27;
  min-height: 20px;
  text-align: center;
  padding: 10px;
}
.auth-toast-icon {
  width: 20px;
  height: 20px;
  display: inline-block;
  padding: 2px 6px;
  vertical-align: middle;
  background: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjAgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzLjIgKDcyNjQzKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5Db21iaW5lZCBTaGFwZTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSLnlLvmnb8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yOTYuMDAwMDAwLCAtMTE3LjAwMDAwMCkiIGZpbGw9IiNGRkFCMjciIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cC03IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzMuMDAwMDAwLCAxMDcuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTczLDMwIEMxNjcuNDc3MTUzLDMwIDE2MywyNS41MjI4NDc1IDE2MywyMCBDMTYzLDE0LjQ3NzE1MjUgMTY3LjQ3NzE1MywxMCAxNzMsMTAgQzE3OC41MjI4NDcsMTAgMTgzLDE0LjQ3NzE1MjUgMTgzLDIwIEMxODMsMjUuNTIyODQ3NSAxNzguNTIyODQ3LDMwIDE3MywzMCBaIE0xNzEuODIzNTI5LDE0LjcwNTg4MjQgTDE3MS44MjM1MjksMjEuNzY0NzA1OSBMMTc0LjE3NjQ3MSwyMS43NjQ3MDU5IEwxNzQuMTc2NDcxLDE0LjcwNTg4MjQgTDE3MS44MjM1MjksMTQuNzA1ODgyNCBaIE0xNzEuODIzNTI5LDIyLjk0MTE3NjUgTDE3MS44MjM1MjksMjUuMjk0MTE3NiBMMTc0LjE3NjQ3MSwyNS4yOTQxMTc2IEwxNzQuMTc2NDcxLDIyLjk0MTE3NjUgTDE3MS44MjM1MjksMjIuOTQxMTc2NSBaIiBpZD0iQ29tYmluZWQtU2hhcGUiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+") no-repeat;
}
.content-box{
  padding: 20px 0 119px;
  height: 470px;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 8px 0 0;
  min-width: 478px;
  color: #4D5365;
  font-size: 14px;
  .dialog-content{
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 24px;
    .create-btn-disable{
      background: #85B2FD;
      border-color: #85B2FD;
    }
    .box-checkbox-inner {
      top: -1px;
    }
  }
  .dialog-content::-webkit-scrollbar {
    width: 8px;
    height: 4px;
  }
  .dialog-content::-webkit-scrollbar-thumb  {
    opacity: 0.6;
    background: #C1C7CD;
    border-radius: 100px;
  }
}
.content-box::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
.content-box::-webkit-scrollbar-thumb {
  opacity: 0.6;
  background: #C1C7CD;
  border-radius: 100px;
}
// .link-button{
//     margin-left: 10px;
//     margin-top: -4px;
//     line-height: 32px;
//     padding: 0 5px;
//     box-sizing: border-box;
//     min-width: 94px;
//     border-radius: 3px;
//     background: #2A7EF8;
//     color: #fff;
//     border: none;
//     cursor: pointer;
//     vertical-align: baseline;
//     &:disabled {
//         background: rgb(136, 183, 241);
//         border-color: rgb(136, 183, 241);
//     }
// }
// .link-button:hover {
//     background: #57A2FF;
// }
.download-btn{
  width: 80px;
  height: 40px;
  display: block;
  background: #2c7df1;
  border: 1px solid #4d5365;
  text-align: center;
  line-height: 40px;
  color: white;
}
/***链接分享***/
.link-row {
  height: 60px;
  width: 100%;
  border-bottom: 1px solid gainsboro;
  box-sizing: border-box;
  position: relative;
  &.add-email > label{
    vertical-align: top;
    display: inline-block;
    line-height: 40px;
    height: 32px;
  }
}
.link_share h1{
  font-size: 14px;
  font-weight: normal;
  margin-top: 23px;
  margin-bottom: 12px;
  color: #7f7f7f;
}
.link-row .link-url-span{
  width: 286px;
  height: 36px;
  vertical-align: middle;
  /*margin-left: 15px;*/
  padding-left: 10px;
  text-align: left;
  border: solid 1px #E0E0E0;
  border-radius: 3px;
  display: inline-block;
  margin-right: 9px;
  position: relative}
.no-link-border {
  border: none!important;
  width: 268px;
}
.link-row .approval-tip{
  position: absolute;
  top: 36px;
  background: #fff1dc;
  color: #FFAB27;
  display: none;
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.link-row .link-url-span .link-txt-password{
  display: inline-block;
  left: 207px;
  overflow: hidden;
  position: absolute;
  text-overflow: ellipsis;
  top: 8px;
  white-space: nowrap;
  width: 104px;
}
.remark-row{
  height: 46px;
  & .remark-name {
    border: 1px solid white;
    outline: none;
    width: 216px;
    padding: 5px;
    color: #4D5365;
    border-radius: 2px;
    &:focus {
      border: 1px solid @mainColor;
    }
  }
  .maxlength-warn-txt{
    color: red;
  }
}
.link-option{
  padding-top: 30px;
  .controlled-item{
    .item-wrapper{
      position: relative;
      &.disabled{
        &::before{
          content: '';
          display: inline-block;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          z-index: 1;
          background: hsla(0,0%,100%,.5);
        }
      }
    }
  }
}
.link-option label{
  margin: 6px;
}
.label{
  color: #929CA9;
  font-size: 14px;
}
.secure-config{
  border-bottom: 1px solid gainsboro;
  padding: 24px 0px;
}
.secure-content{
  margin-left: 48px;
}
.link-instruction{
  // margin-top: 20px;
  padding: 24px 0;
  & > input{
    background: hsla(0,0%,97.3%,.4);
    border: 1px solid #fff;
    border-radius: 2px;
    font-size: 12px;
    height: 32px;
    width: 371px!important;
    &:focus {
      border: 1px solid @mainColor;
    }
  }
}
.en {
  .link-instruction{
    & > input{
      width: 354px!important;
    }
  }
}
.rm-link-pwd,.add-link-pwd{
  color: #0a64fa;
  cursor: pointer;
  line-height: 32px;
}
.rm-link-pwd{
  padding-left: 10px;
  font-size: 12px;
}
.url-show{
  width: 303px!important;
}
.icon-checkmark,.icon-checkbox{
  cursor: pointer;
}
input[type="checkbox"]{
  display: none;
}
.update-file{
  line-height: 32px;
}
.mirror-ver-tip{
  font-size: 12px;
  color: #C6CDD7;
}
.no-link{
  color: #67707C;
  line-height: 38px;
}
.has-link{
  display: inline-block;
  width: 192px;
  line-height: 38px;
  text-decoration: underline;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #0a64fa;
}
.has-link:visited{
  color: #0a64fa;
}
.calendar-box{
  display: inline-block;
  vertical-align: middle;
  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 142px;
    input{
      height: 34px;
      border: 1px solid #c6cdd7;
      border-radius: 2px;
    }
  }
}
.calendar-box .m_calender{
  border: 1px solid #c6cdd7;
  border-radius: 2px;
  height: 32px;
  outline: none;
  padding-left: 15px;
  width: 125px;
}
.calendar-box .m_calender input{
  line-height: 32px;
  background: none;
}
.link-em-days{
  color: #929CA9;
  font-size: 12px;
  padding-left: 10px;
}
.link_copy_box{
  opacity: 0;
}
.count{
  display: inline-block;
  color: #929ca9;
  width: auto;
  overflow: hidden;
  padding-left: 12px;
  margin-right: 30px;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
  vertical-align: middle;
}
.link-instruction-input, #add-email{
  display: inline-block;
  margin-left: 20px;
  width: 385px;
  line-height: 1.5;
  min-height: 34px;
  height: auto;
  background: rgba(248, 248, 248, 0.4);
  padding-left: 15px;
  font-size: 12px;
  border: 1px solid #ffffff;
  border-radius: 2px;
}
#add-email{
  padding-left: 0px;
}
.delivery-qrcode{
  width: 120px;
  height: 120px;
}
.link-share-two-dimensional-code-icon {
  background: url(../source/qrcode-icon.png) no-repeat;
  border-radius: 3px;
  display: inline-block;
  height: 32px;
  margin-left: 10px;
  position: absolute;
  top: 6px;
  width: 32px;
}
.link-share-two-dimensional-code-box {
  background-color: #fff;
  position: absolute;
  z-index: 99;
  width: 155px;
  height: 194px;
  top: 34px;
  left: -100px;
  box-shadow: 0px 0 5px 0px hsl(0, 0%, 60%);
  &:before{
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-top: 10px solid #FFF;
    border-left: 10px solid #FFF;
    transform: rotate(45deg);
    position: absolute;
    right: 37px;
    top: -5px;
    box-shadow: -1px -1px 1px 0px rgba(153,153,153, 0.4);
    z-index: -6;
  }
}
.link-share-two-dimensional-code-pic {
  margin: 20px auto 5px;
  width: 120px;
  height: 120px;
  background-color: #fff;
}
.link-share-two-dimensional-code-state {
  text-align: center;
  font-size: 12px;
  color: #575757;
  width: 120px;
  margin: -3px auto;
  height: 18px;
  line-height: 18px;
}
.dialogfooter{
  min-height: 60px;
  padding-top: 20px;
}
#add-email{
  margin-top: 0px;
  width: 322px;
}
.add-email{
  height: auto;
  border: none;
  width: 480px;
  background: #fff;
  text-align: left;
  padding-left: 8px;
}
.sendLink{
  min-width: 48px;
  height: 24px;
  position: absolute;
  border-radius: 3px;
  padding: 0 5px;
  box-sizing: border-box;
  top: 50%;
  margin-top: -12px;
  right: 10px;
  background: #2C7DF1;
  color: #ffffff;
  text-align: center;
  font-size: 12px;
  line-height: 24px;
  border: none;
  outline: none;
  cursor: pointer;
}
.more-option{
  background-color: #fff;
  bottom: 0;
  position: absolute;
  width: 100%;
  padding: 0 12px 20px 12px;
  box-sizing: border-box;
}
.newLink, .historyLink{
  color: #0a64fa;
  cursor: pointer;
}
.newLink{
  float: left;
}
.historyLink{
  float: right;
}
.dl-time{
  position: absolute;
  left: 94px;
  background: #fff;
  width: 140px;
  border: 1px #DDDDDD solid;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2), 0 1px 0 rgba(255, 255, 255, 0.2) inset;
  padding: 5px 0;
  color: #4D5365;
  z-index: 99;
}
.dl-time li{
  padding: 5px 10px;
  cursor: pointer;
}
.dl-time li:hover{
  background: rgba(198, 205, 215, 0.4);
}
.disable-check{
  pointer-events:none;
}
.disable-check:before{
  color: #929CA9!important;
}
.link_ex_msg{
  color: red;
  display: inline-block;
  width: auto;
  vertical-align: middle;
}
.lv-btn.primary-btn{
  padding: 0 2px;
}
.en .config-row {
  & > .label {
    width: 120px;
  }
  .icon-caret_down{
    left: 240px;
  }
  .dl-time{
    left: 124px;
  }
}
</style>
